import request from '@utils/request';
import { custom, getCustom } from '@src/utils/siteLx';
import { LxSiteClick, lxSearchClickInfo } from '@utils/siteLx';
import { pathInfo } from '@src/Router/pathList';

// /api/job/getJobList
export async function getJobList(params) {
  try {
    const {
      page: { pageNo },
      keywords = '',
    } = params;
    const pathname = window.location.pathname.replace('/m', '');
    /* eslint-disable */
    if (pageNo === 1) {
      LxSiteClick({
        bid: lxSearchClickInfo(pathname)?.bid,
        valLab: {
          query_keyword: decodeURIComponent(keywords).trim() || '',
          entry_point: lxSearchClickInfo(pathname)?.entry,
        },
      });

      // 伯乐分享的链接因为路径判断问题 不会携带上queryId，这里手动调用getCustom添加上queryId
      if (pathname === pathInfo.sharePosition) {
        getCustom(decodeURIComponent(keywords).trim() || '');
      }
    }

    const { u_query_id, r_query_id } = custom;
    const res = await request.post(`/api/official/mobile/job/getJobList`, { ...params, u_query_id, r_query_id });
    /* eslint-enable */
    return res;
  } catch (e) {
    return {
      list: [],
      page: {
        ...params?.page,
      },
    };
  }
}

// getCity
export async function getCity(params) {
  try {
    const res = await request.post(`/api/official/mobile/city/search`, params);
    return res;
  } catch (e) {
    return [];
  }
}

// getBG
export async function getBG() {
  try {
    const res = await request.get(`/api/official/mobile/job/search/enum?enumType=BG`);
    return res;
  } catch (e) {
    return [];
  }
}

// getJF
export async function getJF() {
  try {
    const res = await request.get(`/api/official/mobile/job/search/enum?enumType=JF`);
    return res;
  } catch (e) {
    return [];
  }
}

// getHIRING
export async function getHIRING(jobType: string) {
  try {
    const res = await request.get(`/api/official/mobile/job/search/enum?enumType=${jobType}`);
    return res;
  } catch (e) {
    return [];
  }
}

export async function getEnCityList() {
  try {
    const res = await request.post(`/api/official/en/city/search`);
    return res;
  } catch (e) {
    return [];
  }
}
